

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,

      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
        estado: false
      },
      tabla: {
        meses: [],
        data: []
      }


    };
  },

  computed: {
    reporte: function () {
      return '/SERVER/scd/excel/?dsis='+window.sssdi+'&a=cuponesLi' + '&desde=' + this.f_c.desde + '&hasta=' + this.f_c.hasta + '&filt=' + this.f_c.estado

    }
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,

      'rowCallback': function (row, data, index) { },



    });
    $('.box').boxWidget();
    
  },

  methods: {

    descargar() {

      this.to_excel_name2($("#dett").html(), 'dett', 'Venta por Terminal');

    },
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/SERVER/scd/estadisticas/', {
          'a': 'ventaTe',
          'f': this.f_c
        }, {
          withCredentials: true
        })
        .then(response => {
          
          this.ventast_tabla = 0; 
          if (response.data.status == 1) {

	          this.tabla.meses = response.data.meses;
 

 
              this.tabla.data = response.data.data;
             
            }
          

          this.loading = false;
        });
        

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/estadisticas/ventaTerminal/tventas/tventas.js